/* VH FAQ (sections/vh-faq.liquid). PRESENTATION ONLY: the list fades up once on scroll. Questions open with native <details>. */
(function () {
  var root = document.getElementById('vh-faq');
  if (root && window.VHK) VHK.reveals(root);
})();
